import type { Dict } from './index';

// Basitleştirilmiş Çince sözlük — Claude tarafından elle çevrildi (06.08.2026),
// makine çevirisi kullanılmadı. en.ts ile aynı yapıda olmalı (tip zorunlu kılar).
export const zhHans: Dict = {
  signInMethods: {
    googleLinked: "Google 账号已关联。",
    googleCodeSent: "验证码已发送至尾号为 {phone} 的已登记手机号。",
    googleChooseHint: "你选择的 Google 账号将用于登录此 nosubject 账号。",
    googleStatusUnknown: "无法检查 Google 关联状态，请重试。",
    googleLinkIntro: "关联 Google 前，请先验证此账号已登记的手机号。",
    googleLinkFailed: "无法完成请求，请重试。",
    googleSendCode: "发送验证码",
    googleCodeLabel: "验证码",
    googleStartAgain: "重新开始",
    googleContinue: "使用 Google 继续",
    googleFailed: "无法完成 Google 登录，请重试。",
    googleNotLinked: "此 Google 账号尚未关联 nosubject 账号。",
    googleUnavailable: "Google 登录暂不可用。",
    title: "登录方式",
    intro: "此部分正在准备中。管理登录方式的功能将在后续添加。",
    identity: "身份验证",
    identityInfo: "身份验证与登录账号是两个不同的流程。",
  },
  safety: {
    title: '安全码',
    compare: '请与{name}核对此安全码。如果一致，就没有人能从中间读取你们的消息。',
    explainInfo: '安全码由你们双方当前所有设备的加密密钥计算得出，在两部手机上显示相同。如果其中一方添加了新设备，例如新手机或网页版，安全码会改变，届时请重新核对。验证记录只保存在这台设备上。',
    qrLabel: '安全码的二维码',
    verified: '已验证',
    notVerified: '未验证',
    markVerified: '标记为已验证',
    clearVerified: '取消验证',
    peerUnavailable: '与此人的加密尚未开启。',
    selfUnavailable: '此设备的加密密钥尚未准备好。',
    loadFailed: '无法加载安全码。',
  },
  backup: {
    title: '聊天备份',
    explainInfo: '你的记录保存在这台设备上。备份会用你的恢复码加密后存到服务器，我们无法打开。',
    create: '创建备份',
    refresh: '更新备份',
    codeTitle: '你的恢复码',
    codeWarning: '请把这串码保存在安全的地方。丢失后记录无法找回，我们也打不开。',
    restoreTitle: '恢复记录',
    restorePlaceholder: '恢复码',
    restore: '恢复',
    restored: '已恢复 {count} 条消息。',
    restoreFailed: '无法打开记录，请检查恢复码。',
    failed: '备份失败。',
  },
  common: {
    infoHide: '隐藏说明：{subject}',
    infoShow: '显示说明：{subject}',
    continue: '继续',
    cancel: '取消',
    close: '关闭',
    save: '保存',
    done: '完成',
    retry: '重试',
    error: '错误',
    back: '返回',
    search: '搜索…',
    loading: '正在加载',
    remove: '移除',
    offline: '无法连接服务器。请检查网络。',
    sessionExpired: '登录已过期。请重新登录。',
    tooManyRequests: '请求过于频繁。请稍候再试。',
  },
  time: {
    now: '刚刚',
    minAgo: '{n}分钟前',
    hourAgo: '{n}小时前',
    yesterday: '昨天',
    dayAgo: '{n}天前',
    weekAgo: '{n}周前',
    weekAgoOne: '{n}周前',
    today: '今天',
    dayYesterday: '昨天',
  },
  phone: {
    sendFailed: "无法发送验证码，请重试。",
    subtitle: '请输入你的手机号',
    selectCountry: '国家/地区',
    countrySearch: '搜索国家…',
    architectureLink: '技术架构与路线图 ↗',

  },
  otp: {
    verifyFailed: "无法验证验证码，请重试。",
    invalidCode: "验证码无效或已过期。",
    rateLimited: "尝试次数过多，请稍后重试。",
    title: '输入验证码',
    sentTo: '我们已发送短信至{phone}',
    verify: '验证',
    resend: '重新发送',

    tooManyAttempts: '尝试次数过多。请稍候再试。',

    resendSent: '已发送新验证码。',
    resendFailed: '无法发送验证码。请检查网络后重试。',
    resendWait: '{n} 秒后可再次请求',
  },
  university: {
    title: '你就读于哪所大学？',
    subtitle: '搜索查找',
    placeholder: '哈佛、牛津…',
    skip: '跳过',
  },
  profession: {
    title: '你是做什么工作的？',
    subtitle: '搜索你的职业',
    placeholder: '教师、开发者、护士…',
    skip: '跳过',
  },
  isco: {
    '0': '军队',
    '1': '管理人员',
    '2': '专业技术人员',
    '3': '技术员及助理专业人员',
    '4': '办事人员',
    '5': '服务和销售人员',
    '6': '农林牧渔业人员',
    '7': '技艺及相关行业人员',
    '8': '机器操作及装配人员',
    '9': '非技术工人',
  },
  isced: {
    '5': '专科',
    '6': '本科',
    '7': '硕士',
    '8': '博士',
  },
  profileCreate: {
    photoPickerFailed: "无法打开照片图库。",
    title: '创建你的资料',
    addPhoto: '添加照片',
    name: '你的名字',
    surname: '你的姓氏',
  },
  terms: {
    title: '开始之前',
    age: '我已年满18岁',
    accept: '我已阅读并同意服务条款和隐私政策',
    termsLink: '服务条款',
    privacyLink: '隐私政策',
    continue: '同意并继续',
    saveFailed: '无法保存你的同意。请检查网络后重试。',
    docPlaceholder: '该文档即将发布。',
  },
  locationConsent: {
    title: '位置，仅在你同意时使用',
    body: '为了在拍照后建议所在区县和城市，我们需要位置权限。',
    privacy: '此步骤不会读取你的位置。仅在成功拍照后才会使用位置，且不会存储精确坐标。你可以稍后在设备设置中更改权限。',
    allow: '允许使用位置',
    later: '暂不',
  },
  discover: {
    title: "发现",
    categories: "职业类别",
    categoryHint: "按个人资料中分享的职业发现用户。",
    all: "全部",
    reset: "清除筛选",
    failed: '加载失败',
    free: '免费',
    empty: '这里还没有人',
  },
  userProfile: {
    smsVerifiedOn: "手机已通过短信验证 · {date}",
    googleLinkedOn: "已关联 Google 账号 · {date}",
    contactProofNote: "仅确认可使用该手机或 Google 账号，并非个人身份认证。",
    failed: '无法加载资料',
    sendMessage: '发送消息',
    buyTime: '发出见面邀请',
    block: '拉黑',
    blockedNotice: '已屏蔽 {name}。消息、通话和会面均已关闭。',
    blockTitle: '要拉黑{name}吗？',
    blockMessage: '对方将无法给你发消息，也无法在发现页找到你。',
    blockConfirm: '拉黑',
  },
  callHistory: {
    empty: '暂无通话',
    tabAll: '全部',
    tabMissed: '未接',
    emptyMissed: '没有未接来电',
    failed: '无法加载通话',
    outgoing: '拨出',
    incoming: '来电',
    missed: '未接',
    declined: '已拒绝',
    cancelled: '已取消',
  },
  call: {
    title: '语音通话',
    calling: '正在呼叫…',
    incoming: '来电',
    connecting: '正在连接…',
    connected: '已接通',
    reconnecting: '正在重新连接…',
    logAnswered: '语音通话',
    logAnsweredVideo: '视频通话',
    logNoAnswer: '无人接听',
    logMissed: '未接来电',
    logDeclined: '通话被拒接',
    logYouDeclined: '你拒接了通话',
    logCancelled: '通话已取消',
    ended: '通话结束',
    accept: '接听',
    decline: '拒接',
    hangUp: '挂断',
    close: '关闭',
    mute: '关闭麦克风',
    unmute: '开启麦克风',
    cameraOff: '关闭摄像头',
    cameraOn: '开启摄像头',
    flipCamera: '切换摄像头',
    audioOutput: '音频输出：{route}',
    audioOutputTitle: '选择音频输出',
    earpiece: '听筒',
    speaker: '扬声器',
    bluetooth: '蓝牙',
    bluetoothPermissionDenied: '蓝牙权限已关闭。请在设置中开启。',
    wiredHeadset: '有线耳机',
    audioRouteFailed: '无法更改音频输出',
    acceptFailed: '无法接听通话，请重试。',
    declineFailed: '无法拒绝通话，请重试。',
    endFailed: '无法结束通话，请重试。',
    mediaConnectionFailed: '无法建立音频连接，通话已结束且未计费。',
    remaining: '剩余 {time}',
    endingSoon: '本次通话即将结束。',
    spent: '已花费 {amount}',
    earned: '已赚取 {amount}',
    noAudioNotice: '此版本尚不传输音频。通话流程和计费正在测试中。',
    failed: '无法发起通话',
    insufficient: '余额不足以发起此通话',
    busy: '对方正在通话中',
    notAllowed: '你们之间至少有一条消息记录后，才能通话',
    notAccepting: '此用户当前不接受通话',
    priceFree: '免费',
    priceChanged: '通话费率已更改。请查看新费率后重试。',
    rateLimited: '呼叫尝试次数过多。请稍候再试。',
    reservationLinkUnavailable: '此预约已无法关联到该通话。你可以改为发起普通通话。',
    missed: '未接来电',
    callNow: '立即通话',
    videoNow: '立即视频通话',
    scheduledStartTitle: '预约通话',
    scheduledStartBody: '与{name}的预约通话开始了。现在拨打吗？',
    schedule: '预约通话',
    scheduleTitle: '预约与{name}的通话',
    subjectPlaceholder: '主题（可选）',
    priceNote: '通话费率：{price}',
    sendReservation: '发送预约请求',
    reservationSent: '请求已发送',
    reservationSentBody: '你的通话预约请求已发送给{name}。',
    reservationFailed: '无法发送通话预约请求',
    reservationBubble: '☎️ 已请求通话预约',
    reservationBubbleShort: '☎️ 通话预约',
    reservationLabel: '语音通话预约',
    rescheduleBubble: '☎️ 已提议新的通话时间',
    rescheduleBubbleShort: '☎️ 新的通话时间',
  },
  wallet: {
    title: '钱包',
    failed: '无法加载钱包',
    availableBalance: '可用余额',
    earningsTitle: '我的收入',
    earningsTotal: '累计收入',
    earningsWithdrawable: '可提现金额',
    earningsEscrow: '托管中',
    addFunds: '充值',
    addFundsDemo: '演示：为你的账户添加测试余额',
    addFundsFailed: '充值失败。',
    topupLabel: '已充值',
    transactions: '交易记录',
    noTransactions: '暂无交易记录',
    waiting: '待处理',
    incomingRequest: '收到请求',
    replied: '已回复',
    earned: '已获得',
    refunded: '已退款',
    requestPayout: '提现',
    payoutHint: '最多可提现 {amount}。',
    payoutAll: '选择全部金额',
    payoutRequested: '申请已收到',
    payoutRequestedBody: '已创建 {amount} 的提现申请，将尽快处理。',
    payoutFailed: '无法创建提现申请',
    payoutRequests: '提现申请',
    noPayouts: '暂无提现请求',
    payoutStatusPending: '待处理',
    payoutStatusPaid: '已支付',
    payoutStatusRejected: '已拒绝',
    paymentAccount: '收款账户',
    stripeConnect: '连接收款账户',
    stripeConnectInfo: '绑定银行账户以接收收入（Stripe，测试模式）',
    stripeConnected: '已连接',
    stripeConnectFailed: '连接失败',
  },
  calendar: {
    dateInputLabel: "日期",
    timeInputLabel: "时间",
    dateInputHint: "请以 YYYY-MM-DD 格式输入年、月、日。",
    timeInputHint: "请以 24 小时制的 HH:MM 格式输入时间。",

    previousWeek: '上一周',
    nextWeek: '下一周',
    empty: '没有可显示的请求',
    failed: '日历加载失败',
    statusPending: '待处理',
    statusAccepted: '已接受',
    statusDeclined: '已拒绝',
    statusCancelled: '已取消',
    statusExpired: '已过期',
    accept: '接受',
    decline: '拒绝',
    cancel: '取消',
    cancelConfirmationTitle: '取消此预约？',
    cancelConfirmationAcceptedBody: '与{name}的已确认预约将被取消。对方会收到通知，且此操作无法撤销。',
    cancelConfirmationPendingBody: '发送给{name}的邀请将被撤回。对方会收到通知，且此操作无法撤销。',
    actionFailed: '操作失败',
    proposeTitle: '向{name}发出见面邀请',
    locationPlaceholder: '地点（可选）',
    sendProposal: '发送邀请',
    proposalSent: '邀请已发送',
    proposalSentBody: '你的见面邀请已发送给{name}。',
    priceChangedBody: '此预约的每分钟费率已变为 {amount}。邀请尚未创建，请查看新费率后重新发送邀请。',
    proposalFailed: '邀请发送失败',
    meetupBubble: '📅 已发出见面邀请',
    meetupBubbleShort: '📅 见面邀请',
    proposeAction: '📅 发出见面邀请',
    priceNote: '线下见面费用：{price}',
    totalCost: '总计：{amount}',
    minutesShort: '分钟',
    tabRequests: '请求',
    tabCalendar: '日历',
    tabActive: '当前',
    tabHistory: '历史',
    loadMore: '显示更多',
    noEventsForDay: '这一天没有日程',
    meetupLabel: '线下见面',
    reservationDetails: '预约详情',
    reservationParticipant: '对方',
    reservationHeld: '通话已进行',
    reservationNotHeld: '未进行通话',
    reservationDateTime: '日期和时间',
    reservationDuration: '时长',
    reservationRate: '每分钟',
    reservationLocation: '地点',
    reservationSubject: '主题',
    reservationQuotedTotal: '报价总额',
    reservationBilledDuration: '计费时长',
    reservationSpentAmount: '支付金额',
    reservationEarnedAmount: '收益金额',
    reservationSettledAt: '结算时间',
    reservationCreated: '创建时间',
    reservationResponded: '回复时间',
    reservationAcceptedAt: '接受时间',
    reservationDeclinedAt: '拒绝时间',
    reservationCancelledAt: '取消时间',
    reservationCancelledBy: '取消者',
    reservationYou: '你',
    reservationCancellationNotification: '通知发送',
    reservationNotificationPending: '准备中',
    reservationNotificationProviderAccepted: '发送服务已接受',
    reservationNotificationSuppressed: '因通知偏好设置而未发送',
    reservationNotificationUnavailable: '未找到符合条件的设备',
    reservationPendingReschedule: '建议的新时间',
    reservationNewTime: '新的日期和时间',
    proposeNewTime: '建议新时间',
    rescheduleFuture: '新时间必须晚于现在，并且与预约当前的开始时间至少相差一分钟。',
    reservationCallTooEarly: '此预约通话将在开始前15分钟开放。',
    reservationCallExpired: '此预约的通话时间窗口已结束。',
    reservationCallInProgress: '与此预约关联的通话已经开始。',
    reservationExecutionLocked: '此预约通话已经开始或结束，无法再更改。',
    openReservation: '打开与{name}的预约详情',
    systemEventMeetupTitle: '与{name}见面',
    systemEventCallTitle: '与{name}的预约通话',
    systemEventNotes: '已通过 nosubject 确认。',
    systemCalendarCopyRemoved: '系统日历副本已被删除',
    restoreSystemCalendarCopy: '恢复',
    systemCalendarRestoreFailed: '无法恢复日历副本。请检查日历连接和系统权限。',
    systemCalendarCopyChanged: '系统日历时间已更改',
    reviewSystemCalendarChange: '查看',
    systemCalendarChangeTitle: '日历时间已更改',
    systemCalendarChangeBody: '此更改尚未同步给对方。\n\nnosubject：{nosubject}\n系统日历：{system}',
    restoreNosubjectTime: '恢复为 nosubject 中的时间',
    systemCalendarTimeRestoreFailed: '无法修正日历副本时间。请检查日历连接和系统权限。',
    proposeReschedule: '向对方提议',
    rescheduleSent: '已提议新时间',
    rescheduleSentBody: '新时间提议已发送给{name}。在对方接受前，预约时间保持不变。',
    rescheduleFailed: '无法提议新时间。',
    rescheduleActionFailed: '无法更新时间提议。',
    reschedulePendingReceived: '新时间提议：{time}',
    reschedulePendingSent: '等待回复的新时间：{time}',
    withdrawReschedule: '撤回提议',
    rescheduleBubble: '📅 已提议新的见面时间',
    rescheduleBubbleShort: '📅 新的见面时间',
    connectionsTitle: '日历连接',
    connectionsInfo: '选择要显示的日历',
    deviceCalendar: '设备日历',
    connect: '连接',
    openSettings: '打开设置',
    permissionGranted: '已允许访问',
    permissionDenied: '访问已关闭',
    permissionUnavailable: '此版本不可用',
    permissionNotRequested: '尚未连接',
    devicePermissionInfo: '只有在你点击此按钮后才会请求权限。nosubject 仅读取所选日历和必要的时间范围；此页面不会写入日程。',
    selectCalendars: '要显示的日历',
    noDeviceCalendars: '此设备上没有可用的事件日历。',
    manageSystemPermission: '管理系统日历权限',
    connectionPrivacyInfo: '选择仅保存在此设备的当前账户中。外部日程详情只用于你的日历视图，不会自动与其他用户共享。',
    newBuildRequired: '连接日历需要更新的应用版本。',
    connectionFailed: '无法连接日历。',
    disconnect: '断开连接',
    disconnectTitle: '断开日历连接？',
    disconnectBody: 'nosubject 将停止在此设备上读取日历和写入新接受的日程。已选日历和本地映射会被清除；系统日历中的现有日程会保留。你可以在设备设置中另行撤销系统权限。',
    disconnectFailed: '无法断开日历连接。',
    selectionSaveFailed: '无法保存日历选择。',
    allDay: '全天',
    recurring: '重复',
    availabilityFree: '空闲',
    availabilityBusy: '忙碌',
    availabilityTentative: '暂定',
    availabilityUnavailable: '不可用',
    untitledExternalEvent: '无标题日程',
    externalEventsFailed: '无法加载外部日历日程。',
    hideExternalEvent: '在此视图中隐藏“{title}”',
    hideExternalEventFailed: '无法隐藏日程。',
    restoreHiddenExternalEvents: '重新显示已隐藏的日程',
    restoreHiddenExternalEventsFailed: '无法重新显示已隐藏的日程。',
    hiddenExternalEventCount: '此设备上已隐藏 {count} 个日程',
    checkIncompleteTitle: '日历检查未完成',
    checkIncompleteBody: '至少有一个日历来源暂时无法读取，因此无法确认该时段完全空闲。你仍可选择继续。',
    conflictCheckIncomplete: '部分日历无法读取，因此可能还有其他冲突。',
    conflictTitle: '日历冲突',
    reservationUnavailable: '由于已有另一项已确认的预约，此时间已不可用。',
    reservationChanged: '此预约已在其他页面或设备上更改。我们已加载最新内容。',
    reservationPast: '无法接受开始时间已过的预约。',
    conflictBody: '该时间与你日历中的其他日程重叠。你仍可选择继续。',
    tentativeConflictTitle: '暂定日历事件',
    tentativeConflictBody: '此时间有一个尚未确认的日历事件。继续前请查看详情。',
    conflictMore: '• 其他日程：{count} 个',
    continueAnyway: '仍然继续',
    onlineCalendars: '在线日历',
    googleCalendar: 'Google 日历',
    providerConnected: '已连接',
    providerNotConnected: '未连接',
    providerUnavailable: '官方连接正在准备中',
    googlePrivacyInfo: '仅同步你选择的日历。标题和地点会加密保存在最小化服务器缓存中；描述、参与者和会议链接不会保存。nosubject 无法创建、更改或删除 Google 日历日程。',
    googleConnectionFailed: '无法开始连接 Google 日历。',
    microsoftCalendar: 'Microsoft 日历',
    microsoftInfo: 'nosubject 仅读取你的空闲状态（Calendars.Read），无法创建、修改或删除日程。撤销访问需在 Microsoft 账户设置中完成；nosubject 无法自行撤销。',
    microsoftConnectionFailed: '无法开始连接 Microsoft 日历。',
    googleDisconnectTitle: '断开 Google 日历连接？',
    googleDisconnectBody: 'nosubject 将停止访问 Google 日历数据，并撤销你授予 nosubject 的 Google 权限。Google 日历中的日程不会被删除。',
    googleDisconnectFailed: '无法断开 Google 日历连接。',
    googleNoCalendars: '未找到可读取的 Google 日历。',
    googleSelectionSaveFailed: '无法保存 Google 日历选择。',
  },
  instagram: {
    title: 'Instagram 连接',
    connectInfo: '经明确同意连接你的专业账户',
    connectedAccounts: '已连接账户',
    professionalAccount: '专业账户',
    connect: '连接',
    reconnect: '重新连接',
    connectedAs: '@{username} · {accountType}',
    notConnected: '尚未连接',
    unavailable: '官方连接正在准备中',
    privacyInfo: '第一阶段仅请求 instagram_business_basic，以读取专业账户身份。不会请求消息、评论或发布权限；在你另行选择导入前，也不会将照片复制到 nosubject。',
    business: '企业',
    creator: '创作者',
    connectionFailed: '无法启动 Instagram 连接。',
  },
  inbox: {
    markUnread: '标记为未读',
    markRead: '标记为已读',
    archiveTitle: '存档',
    archive: '存档',
    failed: '无法加载对话',
    searchEmpty: '无结果',
    archivedEmpty: '没有已存档的对话',
    empty: '暂无对话',
    you: '你：',
    archived: '已存档',
    unarchived: '已取消存档',
    undo: '撤销',
    mute: '静音',
    muteTitle: '将{name}静音',
    mute1h: '1小时',
    mute8h: '8小时',
    mute1w: '1周',
    muteForever: '直到我关闭',
    unmute: '取消静音',
    archiveAction: '存档',
    unarchiveAction: '取消存档',
    swipeRemove: '取消存档',
    swipeArchive: '存档',
    blockAction: '拉黑',
    blockTitle: '要拉黑{name}吗？',
    blockMessage: '对方将无法给你发消息，也无法在发现页找到你。',
    blockConfirm: '拉黑',
  },
  message: {
    translationLanguage: "翻译语言",
    chooseTranslationLanguage: "选择翻译语言",
    languageSuggestion: "设备语言建议",
    translationLanguageInfo: "这项私人设置适用于你所有对话的翻译，不会添加到个人资料。",
    photoCaption: "添加照片说明…",
    removePhoto: "移除照片",
    star: "添加星标",
    unstar: "取消星标",
    starred: "星标消息",
    noStars: "此对话中没有星标消息。",
    starFailed: "无法更新星标，请重试。",
    starredAttachment: "带附件的消息",
    edit: "编辑消息",
    edited: "已编辑",
    editInfo: "即使关闭已读回执，消息被读之前仍可编辑。编辑选项消失可能间接表明消息已读。未读不代表从未看见：对方可能已在通知预览中看到原文。编辑不能保证收回说过的话。",
    editFailed: "无法确认编辑。消息可能已被阅读或修改。请先查看聊天再重试。",
    copy: "复制",
    copyFailed: "无法复制消息，请重试。",
    inputPlaceholder: '输入消息…',
    typing: '正在输入',
    translate: '翻译',
    withdrawn: '消息已撤回',
    linkOpenTitle: '打开链接',
    linkOpenBody: '这会带你去 {host}。链接是给你发消息的人发来的——如果不认识对方，请小心。',
    linkOpenConfirm: '打开',
    linkOpenFailed: '无法打开链接。',
    seenAt: '已读 {time}',

    priceChangedTitle: '价格已变',
    priceChangedBody: '这条消息现在是 {new}，不是 {old}。仍要发送吗？',
    priceChangedSend: '发送',
    priceNoticeTitle: '和这个人交流的费用',
    priceNoticeMessage: '每条消息 {amount}',
    priceNoticeCall: '通话 {amount}',
    priceNoticePersonal: '这些费率是专门为你设定的。',
    priceDecreasedTitle: "消息价格已降低",
    priceDecreasedBody: "消息费用已从{old}降至{new}，无需确认较低的价格。",
    priceChange: {
      free: '免费',
    },
    expired: '已过期，已退款',
    // 9.2 / D-650 — web'den gönderilen mesajın saat satırındaki notu.
    sentFromWeb: '通过网页',
    linkViewLabel: '链接显示方式',
    linkViewPlain: '纯地址',
    linkViewCompact: '紧凑',
    linkViewCard: '大卡片',
    linkPreviewLoading: '正在生成预览…',
    linkPreviewFailed: '无法获取此链接的预览，将以纯地址发送。',
    linkPreviewA11y: '链接：{title}，{host}',
    customPrice: '自定义价格',
    priceUsesGeneral: '适用我的通用价格',
    priceRemove: '移出联系人',
    priceRemoveTitle: '把 {name} 移出联系人吗？',
    priceRemoveBody: '专属价格会取消，{name} 恢复按你的通用价格。如果只有联系人能给你发消息，对方就无法再开启新对话。这不是拉黑。',
    priceRemoveConfirm: '移出',
    priceRemoved: '{name} 已恢复通用价格。',
    pricePrompt: '为{name}设置的价格（0 = 免费）：',
    saved: '已保存',
    priceFreeSet: '{name}现在可以免费给你发消息了。',
    priceSet: '{name}的消息价格已设置为{price}。',
    saveError: '保存失败。',
    photoError: '照片发送失败。',
    noConnection: '无网络连接',
    checkInternet: '请检查你的网络连接。',
    sendError: '消息发送失败。',
    addAttachment: '添加附件',
    sendMessageAction: '发送消息',
    lowBalanceTitle: '余额不足',
    lowBalanceBody: '你的余额低于对方的消息价格。请充值后重试。',
    reply: '回复',
    reactionA11y: '{emoji} 表情回应，共 {count} 个',
    reactionA11yMine: '{emoji} 表情回应，共 {count} 个，其中包括你的回应',
    reactionAdd: '用 {emoji} 回应',
    moreReactions: '更多表情',
    reactionRemove: '移除你的 {emoji} 回应',
    you: '你',
    photo: '📷 照片',
    takePhoto: '拍照',
    choosePhoto: '从相册选择',
    chooseVideo: '选择视频',
    recordVoice: '语音消息',
    micPermissionTitle: '需要麦克风权限',
    micPermissionBody: '录制语音消息需要麦克风权限。',
    voiceError: '语音消息发送失败',
    voiceRecording: '录音中',
    videoTooLarge: '视频太大（最大 1 GB）',
    videoTooLong: '视频太长（最长 10 分钟）',
    videoError: '视频发送失败',
    videoNeedsUpdate: '更新应用后即可观看此视频',
    voiceNeedsUpdate: '更新应用后即可播放此语音消息',
    voiceOrderTitle: '已预订语音消息',
    encrypted: '加密消息',
    identityChanged: '对方的安全密钥已更改。这通常意味着换了新手机或重装了应用。',
    identityChangedVerify: '你曾验证过此聊天，请重新核对安全码。',
    unencrypted: '此聊天未加密',
    unencryptedPeerInfo: '对方的应用尚不支持端到端加密，因此你在这里写的内容会以未加密形式发送，并可在 nosubject 的服务器上被读取。对方更新应用后，新消息会自动加密。',
    unencryptedOfficialInfo: '这是 nosubject 的官方账号。你在这里写的内容会以未加密形式发送，nosubject 团队可以读取。',
    unencryptedSelfInfo: '此设备无法开启加密（例如浏览器的隐私窗口无法保存密钥）。你从这里发送的内容不会加密，并可在 nosubject 的服务器上被读取。',
    notificationOfferEnable: '开启通知',
    notificationOfferEnabled: '通知已开启',
    voiceOrderPending: '等待送达',
    voiceOrderDelivered: '已送达',
    voiceOrderDeclined: '已拒绝，已退款',
    voiceOrderExpired: '已过期，已退款',
    voiceOrderAction: '订一条语音',
    voiceOrderPick: '录多长？',
    voiceOrderInsufficient: '余额不够下这笔订单。',
    voiceOrderError: '下单失败。',
    voiceOrderRecord: '录音并发送',
    voiceOrderDecline: '拒绝',
    voiceOrderDeclineTitle: '拒绝订单',
    voiceOrderDeclineBody: '预留的金额将全部退回给下单的人。',
    voiceOrderDeclineError: '拒绝订单失败。',
    voiceOrderDeliverError: '录音发送失败。',
    voiceOrderRecording: '订单录音',
    voiceOrderRemaining: '还剩 {length}',
    voiceOrderShortNote: '录得短一些，也只按录到的时长付费。',
    voiceOrderRefunded: '已退还 {amount}',
    sendLocation: '发送位置',
    locationTitle: '位置',
    locationError: '无法发送位置',
    shareLiveLocation: '共享实时位置',
    liveLocationHour: '1 小时',
    liveLocationEightHours: '8 小时',
    liveLocationOpenEnded: '直到我停止',
    liveLocationSharing: '正在共享你的实时位置',
    liveLocationStop: '停止',
    liveLocationError: '无法开始共享实时位置',
    liveLocationCardTitle: '实时位置',
    liveLocationCardActive: '正在共享',
    liveLocationCardEnded: '共享已结束',
    liveLocationOpen: '查看位置',
    liveLocationNoPoint: '暂无位置',
    liveLocationOpenInMaps: '在地图中打开',
    liveLocationUpdatedAgo: '{ago}更新',
    videoShort: '🎬 视频',
    voiceShort: '🎙 语音消息',
    liveLocationWatchedAgo: '{ago}前查看过',
    liveLocationNotWatched: '尚未查看',
    liveLocationSharerSeesYou: '对方能看到你何时查看',
    cameraPermissionTitle: '需要相机权限',
    cameraPermissionBody: '请允许访问相机，以便拍摄照片。',
    cameraError: '无法打开相机。',
    photoLocationTitle: '照片位置',
    photoLocationPromptFile: '已从照片文件中读取“{place}”。是否随照片显示此位置？',
    photoLocationPromptCapture: '设备位置显示为“{place}”。是否随照片显示此位置？',
    photoLocationHide: '不带位置发送',
    photoLocationShare: '带位置发送',
    photoLocationFromFile: '读取自文件',
    photoLocationFromCapture: '设备位置',
    photoLocationHideAfter: '隐藏位置',
    photoLocationShowAfter: '显示位置',
    photoLocationUpdateError: '无法更新照片位置。',
  },
  versionNotice: {
    title: '有新版本可用',
    body: '请更新应用，以获得安全改进和新功能。',
    update: '更新',
  },
  notifications: {
    title: '通知',
    cardBody: '开启设备通知，以免错过新消息和回复。',
    notNow: '暂不开启',
    enable: '开启通知',
    device: '设备通知',
    stateOn: '已开启 · 在系统设置中管理',
    stateOff: '已关闭 · 在系统设置中开启',
    stateAsk: '尚未询问',
    preferences: '通知偏好',
    preferencesInfo: '管理类别、预览和设备权限',
    stateUnsupported: '此设备不支持',
    master: '所有通知',
    masterInfo: '关闭此开关后将停止所有推送通知，但会保留各类别的设置',
    categories: '类别',
    categoryEnabled: '此类别的通知',
    categoryEnabledInfo: '关闭此开关后将停止此类别的推送通知，但会保留其中的设置',
    events: '事件',
    messages: '消息',
    messagesInfo: '新消息和回复',
    meetups: '见面',
    meetupsInfo: '邀请、变更和结果',
    meetupRequests: '新的见面邀请',
    meetupRequestsInfo: '当有人向你发送新的见面邀请时',
    meetupUpdates: '回复与取消',
    meetupUpdatesInfo: '当见面被接受、拒绝或取消时',
    meetupReminders: '见面提醒',
    meetupRemindersInfo: '当已接受的见面即将开始时',
    calls: '通话',
    callsInfo: '来电、预约通话和未接来电',
    incomingCalls: '来电',
    incomingCallsInfo: '有人呼叫你时发出声音提醒',
    callRequests: '预约通话邀请',
    callRequestsInfo: '当邀请被创建、接受、拒绝或取消时',
    callReminders: '预约通话提醒',
    callRemindersInfo: '当已接受的预约通话即将开始时',
    missedCalls: '未接来电',
    missedCallsInfo: '当你未能接听通话时',
    financial: '资金与托管',
    financialInfo: '交易状态变更',
    financialEarnings: '收入与托管',
    financialEarningsInfo: '当托管资金释放或收入可用时',
    financialRefunds: '退款与到期',
    financialRefundsInfo: '当付款被退回或托管到期时',
    financialPayouts: '提现结果',
    financialPayoutsInfo: '当提现申请成功或失败时',
    reactions: '表情回应',
    reactionsInfo: '他人对你消息的回应', official: '来自 Nosubject', officialInfo: 'Nosubject 关于版本、安全和你的账户的公告。与其他通知分开设置；关闭后 Nosubject 不再发送通知，但消息仍会进入收件箱。',
    preview: '消息预览',
    previewHidden: '隐藏',
    previewHiddenInfo: '不显示发送者或消息',
    previewSender: '仅发送者',
    previewSenderInfo: '显示发送者，隐藏消息',
    previewText: '发送者和消息',
    previewTextInfo: '最多显示80个字符',
    deviceInfo: '系统权限仅适用于此设备',
    openSettings: '打开设置',
    centerTitle: '通知中心',
    centerMarkAll: '全部标为已读', centerMarkedAll: '已全部标为已读',
    centerEmpty: '暂无通知。',
    centerFailed: '无法加载通知。',
    centerMarkAllFailed: '无法将通知标为已读。',
    centerUnknownPerson: '某人',
    centerEscrowExpiredRefunded: '托管已到期 · 款项已退还',
    centerEscrowReleasedEarning: '已回复 · 收益已入账',
    centerMeetupRequest: '{name}向你发送了见面邀请',
    centerCallRequest: '{name}向你发送了预约通话邀请',
    centerCallReminder: '与{name}的预约通话即将开始',
    centerCallStarting: '与{name}的预约通话开始了',
    centerMeetupStarting: '与{name}的见面开始了',
    centerMeetupReminder: '与{name}的见面即将开始',
    centerMeetupUpdate: '{name} · 见面：{status}',
    centerCallUpdate: '{name} · 预约通话：{status}',
    centerMeetupRescheduleRequest: '{name}提议了新的见面时间',
    centerCallRescheduleRequest: '{name}提议了新的通话时间',
    centerMeetupRescheduleUpdate: '{name} · 新的见面时间：{status}',
    centerCallRescheduleUpdate: '{name} · 新的通话时间：{status}',
    centerBell: '通知中心',
    centerBellUnread: '通知中心，{count} 条未读通知',
  },
  profile: {
    webVisibility: '谁可以查看我的网页',
    webVisibilityLink: '有链接的人',
    webVisibilityInfo: '没有账号的人看到的你的个人资料：你在 nosubject.co/你的用户名 的页面。所有人：页面也可能出现在搜索引擎中。有链接的人：知道地址的人可以打开；搜索引擎不会收录。在这两种情况下，没有账号的人都能获取你的个人资料信息，包括你的最后在线时间。任何人都不可以：没有账号的人都看不到你的个人资料，页面显示“此个人资料不可用”。你在应用中的个人资料不变。从搜索结果中消失可能需要几天。',
    linkViewInfo: '选择你输入的链接如何发送。选择紧凑或大卡片时，你的手机会打开该页面一次，并把预览随消息一起发送；该网站会看到你手机的 IP 地址。在加密聊天中，预览位于加密内容中；在未加密聊天中，nosubject 能看到链接和预览。纯地址不会打开任何页面。从网页版发送的链接始终以纯地址发送。',
    linkViewAsk: '输入时显示选项',
    linkViewAskInfo: '开启后，输入链接时会出现另外两种显示方式，你可以为这条消息选择一种。关闭后，链接始终以这里选择的方式发送。',
    whoCanCallInfo: '选择谁可以给你打电话；每次通话都适用。我的联系人是你设置了专属价格的人。在例外中，你可以逐个允许或屏蔽某人。',
    whoCanMessageInfo: '选择谁可以与你开始新的对话；已经开始的对话不受影响。我的联系人是你设置了专属价格的人。在例外中，你可以逐个允许或屏蔽某人。',
    readReceiptsInfo: "只有双方都开启时才显示已读回执。即使关闭，编辑选项消失仍可能表明消息已读。",
    showTypingInfo: '开启后，你输入时对方可以看到你正在输入。关闭后，谁都看不到，但你仍然可以看到别人正在输入。',
    officialAccount: '官方账号',
    information: '个人资料信息',
    logout: '退出登录',
    account: '账户',
    accountData: '账户与数据',
    name: '名字',
    surname: '姓氏',
    username: '用户名',
    usernamePlaceholder: '用户名',
    usernameChecking: '检查中…',
    usernameAvailable: '可用',
    usernameTaken: '该用户名已被占用',
    usernameInvalid: '3–20个字符，首字符须为A–Z或a–z；仅可使用A–Z、a–z、0–9和_。',
    usernameAdd: '添加用户名',
    profession: '职业',
    professionNone: '尚未添加职业',
    professionAdd: '添加职业',
    employer: '任职公司',
    employerPlaceholder: '公司用户名',
    employerInfo: '请输入一个现有的 nosubject 用户名。此标注不代表任职关系已经核实。',
    employerNotFound: '未找到使用该用户名的有效账户。',
    employerSelf: '不能将自己的账户标注为任职公司。',
    bio: '介绍一下自己…',
    prices: '价格',
    settings: '设置',
    priceMessage: '消息',
    priceVoice: '语音消息（每分钟）',
    priceVoiceShort: '语音消息',
    priceCall: '立即通话（每分钟）',
    priceCallShort: '立即通话',
    priceScheduledCall: '预约通话（每分钟）',
    priceScheduledCallShort: '预约通话',
    priceVideoCall: '视频通话',
    priceVideoCallShort: '视频',
    priceTime: '线下见面（每分钟）',
    priceTimeShort: '线下见面',
    currency: '货币',
    saving: '保存中…',
    wallet: '钱包',
    chatBackup: '聊天备份',
    privacy: '隐私',
    readReceipts: '已读回执',
    showTyping: '正在输入提示',
    keepArchived: '保持存档',
    keepArchivedInfo: '关闭后，新消息会将对话移出存档',
    whoCanMessage: '谁可以给我发消息',
    whoCanCall: '谁可以给我打电话',
    messagesFromContact: '来自此用户的消息',
    callsFromContact: '来自此用户的通话',
    callExceptions: '例外',
    callExceptionsEmpty: '暂无通话例外',
    messageExceptionsEmpty: '暂无消息例外',
    exceptionsLoadFailed: '无法加载例外',
    openProfileHint: '打开此人的资料',
    callExceptionBlocked: '已拉黑',
    callsFromContactDefault: '默认',
    callsFromContactAllow: '始终允许',
    callsFromContactBlock: '从不',
    everyone: '所有人',
    contacts: '我的联系人',
    nobody: '任何人都不可以',
    blockedUsers: '已拉黑的用户',
    blockedEmpty: '你还没有拉黑任何人',
    unblock: '取消拉黑',
    appearance: '外观',
    light: '浅色',
    dark: '深色',
    system: '系统',
    displayLanguage: '应用语言',
    education: '大学',
    educationAdd: '添加大学',
    educationNone: '尚未添加大学',
    educationLevel: '学历',
    searchLanguage: '搜索语言…',
    photoChange: '更换',
    saveFailed: '保存失败。',
    photoFailed: '照片上传失败。',
    photoChanged: "照片已在其他操作中更改，或重试期限已过。请重新选择照片。",
    deleteAccount: '删除账户',
    deleteTitle: '删除你的账户',
    deleteMessage: '你的账户将在30天后被永久删除。在此期间你可以重新登录取消删除。',
    deleteMoneyWarning: '你的钱包余额和托管资金合计还有{amount}。建议在删除账户前提现。',
    deleteConfirm: '删除',
    deleteFailed: '账户删除失败。',
    deletionScheduled: '你的账户将于{date}被删除。',
    deletionCancel: '取消删除账户',
    exportData: '下载我的数据',
    exportFailed: '无法获取数据。',
  },
  // Alt bar (dock) — ekran okuyucu etiketleri ve rozet sayıları (9.26.7.2.1)
  dock: {
    calls: '通话',
    discover: '发现',
    inbox: '消息',
    calendar: '日历',
    profile: '个人资料',
    unreadMessages: '{count} 条未读',
    pendingRequests: '{count} 个待处理',
  },
};
